import { basicEnum } from "./base";

export const NetworkUsageTypeEnum = basicEnum([
    {
        label: "-",
        value: "NONE",
    },
    {
        label: "Network Address",
        value: "NETWORK",
    },
    {
        label: "Broadcast Address",
        value: "BROADCAST",
    },
    {
        label: "Langganan",
        value: "SUBSCRIPTION",
    },
]);

export namespace NetworkUsageTypeEnum {
    export type Labels = (typeof NetworkUsageTypeEnum)["labels"][number];
    export type Values = (typeof NetworkUsageTypeEnum)["values"][number];
}
